import Repository from './repository'
const resource = '/latest_archived_events'

export default {
  get () {
    return Repository.get(resource)
  }
}
